










































import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

@Component
export default class Logout extends Mixins<PluginMixin>(PluginMixin) {
  Status = Status

  status: Status = Status.Pending

  async logout() {
    this.status = Status.Loading

    await this.$store.dispatch('user/logout')

    if (this.$store.state.user.error.logout) {
      this.status = Status.Failed

      return
    }

    this.status = Status.Completed

    /**
     * vue-routerで遷移した場合はcallWithAuth内のキャッシュが破棄されず、
     * aクッキーが存在しないにも関わらずcallWithAuthのAPI呼び出しで事前にregister_provisionalが実行されない。
     *
     * HTTPによるページ遷移を行うことでcallWithAuthのキャッシュを削除する。
     *
     * ただし、これはリリース直前の対応であることを考慮した暫定対応である。
     * 恒久的な対応としてはcallWithAuth自身がPromiseの完了とともにキャッシュを破棄し、
     * 実行されるたびにaクッキーの有無に応じてregister_provisionalの要否を判定できるよう修正するなどの対応が望ましい。
     *
     * @see https://github.com/my-color/front/issues/7455#issuecomment-1653677727
     * @see https://www.chatwork.com/#!rid158613418-1736433312685096960
     */
    location.href = '/s/login'
  }
}

enum Status {
  Pending,
  Loading,
  Failed,
  Completed,
}
